var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMemoryStrengthFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2988",
    fill: "none",
    d: "M0 0h40v40H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Exclusion 5",
    d: "M19.72 35a3.821 3.821 0 01-1.4-.267l-1.363-.533a15.532 15.532 0 01-7.228-5.83A16.052 16.052 0 017 19.384V9.232a1.989 1.989 0 011.132-1.816A27.656 27.656 0 0119.464 5h.514a27.648 27.648 0 0111.33 2.416 1.988 1.988 0 011.132 1.816v10.152a16.052 16.052 0 01-2.729 8.987 15.532 15.532 0 01-7.228 5.83l-1.358.533A3.826 3.826 0 0119.72 35zm-1.359-21a1.118 1.118 0 00-1.023.67l-2.245 5.136a1.115 1.115 0 001.025 1.56h.868l-1.753 4.088a.75.75 0 001.219.826l6.708-6.706a1.116 1.116 0 00-.788-1.907h-.856L23 15.815A1.117 1.117 0 0022.126 14z",
    fill: "#fff"
  })));
}
export default SvgIconMemoryStrengthFull;